import React, { useEffect, useState } from 'react'
import classNames from 'classnames';
import { useForm } from 'react-hook-form';
import { useHistory, useParams } from 'react-router-dom';
import Layout from '../../components/layouts/Layout';
import timeZone from '../../dbJson/timezones.json';
import { Label } from '../../components/Input';
import UploadFile from '../../hook/UploadFile';
import http, { URL_S3 } from '../../config/BaseUrl';
import NewFormWizard from '../../components/formWizard/NewFormWizard';
import { DateTimePickerComponent } from '@syncfusion/ej2-react-calendars';
import moment from 'moment'


const EventInfoEdit = () => {
    const history = useHistory();
    const { id } = useParams();
    const editEventInfo = history.location.state.eventInfo
    const [loading, setLoading] = useState(false);
    const [startDateDefault, setStartDateDefault] = useState(null)
    const [startDate, setStartDate] = useState(null)
    const [endDateDefault, setEndDateDefault] = useState(null)
    const [endDate, setEndDate] = useState(null)
    const [editStartDate, setEditStartDate] = useState(false)
    const [lifeTime, setLifeTime] = useState(false)

    const htmlAttributes = { placeholder: "Select a date and time" };

    const { register, handleSubmit, setError, formState: { errors }, clearErrors } = useForm({
        mode: "onChange",
        reValidateMode: "all",
        defaultValues: {
            event_name: editEventInfo.event_name,
            event_start_date: editEventInfo.event_start_date,
            event_details: editEventInfo.event_details,
            event_end_date: editEventInfo.event_end_date,
            venue_name: editEventInfo.venue_name,
            time_zone: editEventInfo.time_zone,
        }
    });

    useEffect(() => {
        let stDate = new Date(editEventInfo.event_start_date)
        let enDate = new Date(editEventInfo.event_end_date)
        setStartDate(editEventInfo.event_start_date)
        setStartDateDefault(stDate)

        if (editEventInfo.life_time) {
            setLifeTime(true)
        }
        else{
            setEndDate(editEventInfo.event_end_date)
            setEndDateDefault(enDate)
        }

        checkFutureEvent(stDate)

    }, [editEventInfo])

    const dateStartTimeConverter = (value) => {

        setStartDate(moment(value).format('YYYY-MM-DD HH:mm'))
        setStartDateDefault(value)
        if (value) {
            clearErrors('event_start_date')
        }
    }
    const dateEndTimeConverter = (value) => {

        setEndDate(moment(value).format('YYYY-MM-DD HH:mm'))
        setEndDateDefault(value)
        if (value) {
            clearErrors('event_end_date')
        }
    }

    // custom hook
    const { fileURL, onChangeFile } = UploadFile()

    const handelInfo = async (data) => {
        if (lifeTime) {
            if (!startDate || startDate === 'Invalid date') {
                setError("event_start_date", {
                  type: "manual",
                  message: "Event start date is required",
                });
                setTimeout(()=>{
                  clearErrors(['event_start_date'])
                }, 3000)
            }
            else {  
                submitFormData(data)        
            } 
        }
        else{
            if (!startDate || !endDate) {
                if (!startDate || startDate === 'Invalid date') {
                    setError("event_start_date", {
                        type: "manual",
                        message: "Event start date is required",
                    });
                }
                if (!endDate || endDate === 'Invalid date') {
                    setError("event_end_date", {
                        type: "manual",
                        message: "Event end date is required",
                    });
                }

                setTimeout(()=>{
                    clearErrors(['event_start_date', 'event_end_date'])
                }, 3000)
    
            } else {
                submitFormData(data)
            }
        }

    }

    const submitFormData = async (data) => {
        let startDt = new Date(startDate);
        let endDt = new Date(endDate);
        let currentDate = new Date();
        let hours = Math.round(endDt - currentDate) / 36e5;
        
        if (lifeTime) {
            let eDate = lifeTime ? moment().add(200, 'y').format('YYYY-MM-DD HH:mm') : endDate
            setLoading(true)
            try {
                await http.post(`/event/info/update/${id}`, { ...data, event_info_image: fileURL, event_start_date: startDate, event_end_date: eDate, life_time: lifeTime ? 1 : 0 })
                    .then(res => {
                        if (res.data == 'success') {
                            setLoading(false)
                            history.push(`/show/event/${id}`, 'Information Updated.')
                        }
                    })
            } catch (error) {

            }
        }
        else if (hours <= 48 && hours > 0) {
            setLoading(true)
            try {
                await http.post(`/event/info/update/${id}`, { ...data, event_info_image: fileURL, event_start_date: startDate, event_end_date: endDate, life_time: lifeTime ? 1 : 0 })
                    .then(res => {
                        if (res.data == 'success') {
                            setLoading(false)
                            history.push(`/show/event/${id}`, 'Information Updated.')
                        }
                    })
            } catch (error) {

            }
        } else {
            let name = { event_end_date: ["event_end_date"] };
            let nameArr = [["Please select date & time below 48 hour"]];
            const errorNames = Object.keys(name);
            const errorMessages = Object.values(nameArr);
            errorNames.forEach((err, indx) => {
                setError(err, { type: 'required', message: errorMessages[indx][0] })
            })

            setTimeout(() => {
                clearErrors(errorNames)
            }, 3000)

        }
    }

    const checkFutureEvent = (date) => {
        let currentDate = new Date();
        let eventStartDate = new Date(date);
        let hours = Math.ceil(Math.round(currentDate - eventStartDate) / 36e5);
        if (hours > 0) {
            setEditStartDate(true)
        }
        else {
            setEditStartDate(false)
        }

    }

    const checkLifeTime = (e) => {
        setLifeTime(e.target.checked)
    }

    return (
        <Layout>
            <NewFormWizard />
            <form onSubmit={handleSubmit(handelInfo)}>
                <section className="mt-5">
                    <div className="row justify-content-center">
                        <div className="col-md-10">
                            <div className="card">
                                <div className="py-5 text-center border-bottom">
                                    <h4 className="text-primary display-4 event-form-title">Event Information</h4>
                                    <span className="text-secondary">Fill all the information</span>
                                </div>
                                <div className="p-4 card-body">

                                    <div className="form-row">
                                        <div className="form-group col-md-12">
                                            <label htmlFor="">Event name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Event name"
                                                {...register("event_name", { required: true })}
                                            />
                                        </div>

                                        <div className="form-group col-md-6">
                                            <label>Event Start Date & Time</label>
                                            <DateTimePickerComponent
                                                format="dd-MM-yyyy hh:mm"
                                                id="datetimepicker"
                                                htmlAttributes={htmlAttributes}
                                                cssClass="date-time-input"
                                                value={startDateDefault}
                                                min={new Date()}
                                                // readonly={editStartDate}
                                                // disabled={editStartDate}
                                                change={e => { dateStartTimeConverter(e.value) }}
                                            />
                                            <span className="text-danger font-size-14">{errors.event_start_date && errors.event_start_date.message}</span>
                                        </div>
                                        <div className="form-group col-md-6">
                                        <div className='d-flex align-items-center justify-content-between'>
                                                <label>Event Finish Date & Time</label>
                                                <div className="custom-control custom-checkbox life-time-check mb-0">
                                                    <input 
                                                        type="checkbox" 
                                                        className="custom-control-input" 
                                                        id="customCheck1"
                                                        checked={lifeTime ? "checked" : ""}
                                                        onChange={checkLifeTime} 
                                                    />
                                                    <label className="custom-control-label" htmlFor="customCheck1">Ongoing event</label>
                                                </div>
                                            </div>
                                            <DateTimePickerComponent
                                                format="dd-MM-yyyy hh:mm"
                                                id="datetimepicker"
                                                htmlAttributes={htmlAttributes}
                                                cssClass="date-time-input"
                                                value={endDateDefault}
                                                min={new Date()}
                                                disabled={lifeTime}
                                                enabled={!lifeTime}
                                                change={e => { dateEndTimeConverter(e.value) }}
                                            />
                                            <span className="text-danger font-size-14">{errors.event_end_date && errors.event_end_date.message}</span>
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label htmlFor="">Extra Text</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Extra Text"
                                                {...register("event_details", { required: true })}

                                            />
                                        </div>

                                        <div className="form-group col-md-6">
                                            <label htmlFor="">Venue name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Venue name"
                                                {...register("venue_name", { required: true })}

                                            />
                                        </div>

                                        <div className="form-group col-md-6">
                                            <Label htmlFor="eventTimeZone">Timezone</Label>
                                            <select
                                                id="eventTimeZone"
                                                name="time_zone"
                                                className={classNames("form-control", { "is-invalid": errors.time_zone })}
                                                {...register("time_zone", {
                                                    required: "This field is required"
                                                })}
                                            >
                                                <option value="">Select time zone</option>
                                                {timeZone && timeZone.map((res, index) => (
                                                    <option key={index} value={res.text} selected={editEventInfo.time_zone == res.text ? 'selected' : ''} >{res.text}</option>
                                                ))}
                                            </select>
                                            <p className="mt-2 text-danger">{errors.time_zone && errors.time_zone.message}</p>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Event Image</label>
                                                <div className="mb-3 input-group">
                                                    <div className="custom-file">
                                                        <input
                                                            type="file"
                                                            className="custom-file-input"
                                                            id="inputGroupFile01"
                                                            aria-describedby="inputGroupFileAddon01"
                                                            onChange={onChangeFile}
                                                        />
                                                        <label className="custom-file-label" forHtml="inputGroupFile01">
                                                            {
                                                                fileURL ?
                                                                    <img src={fileURL} className="img-fluid" style={{ width: '35px', height: '20px' }} alt="" />
                                                                    :
                                                                    editEventInfo.event_info_image ?
                                                                        <img src={URL_S3 + 'image/event_info/' + editEventInfo.event_info_image} className="img-fluid" style={{ width: '35px', height: '20px' }} alt="" />
                                                                        : 'Choose file'
                                                            }

                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="my-5 row justify-content-center">
                        <div className="col-md-10">
                            <button type="submit" className="float-right px-5 btn btn-primary radius-30">
                                {loading ?
                                    <>
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Updating...
                                    </>
                                    : "Update"
                                }
                            </button>
                        </div>
                    </div>
                </section>
            </form>
        </Layout>
    )
}

export default EventInfoEdit
